export const getTimedTakeout = store => store.timedTakeout
